export const relationshipOptions = [
  { value: 'spouse', label: 'Spouse / Partner' },
  { value: 'parent', label: 'Parent' },
  { value: 'child', label: 'Child' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'relative', label: 'Other Relative' },
  { value: 'friend', label: 'Friend' },
  { value: 'caregiver', label: 'Caregiver' },
  { value: 'guardian', label: 'Legal Guardian' },
  { value: 'physician', label: 'Primary Care Physician' },
  { value: 'other', label: 'Other (please specify)' },
]
